{
  "status": {
    "pending": "Pending",
    "preliminary": "Preliminary",
    "final": "Final",
    "corrected": "Corrected",
    "amended": "Amended",
    "addended": "Addended",
    "enteredInError": "Entered in error",
    "unknown": "Unknown"
  },
  "review": {
    "title": "Results Review",
    "printLabel": "Print Results",
    "summary": {
      "count_one": "{{count}} result",
      "count_other": "{{count}} results",
      "criticalUnacknowledged": "{{count}} critical unacknowledged"
    },
    "view": {
      "timeline": "Timeline",
      "flowsheet": "Flowsheet"
    },
    "filter": {
      "date": "Date",
      "type": "Type",
      "status": "Status",
      "statusAll": "All"
    },
    "dateRange": {
      "h24": "Last 24h",
      "h48": "Last 48h",
      "d7": "Last 7d",
      "d30": "Last 30d",
      "all": "All"
    },
    "resultType": {
      "all": "All",
      "lab": "Lab",
      "imaging": "Imaging",
      "pathology": "Pathology",
      "cardiology": "Cardiology",
      "microbiology": "Microbiology"
    },
    "criticalOnlyToggle": "Critical Only",
    "criticalBadge": "CRITICAL",
    "actions": {
      "acknowledgeCritical": "Acknowledge Critical",
      "acknowledgeAllCritical": "Acknowledge all critical ({{count}})"
    },
    "detail": {
      "resultNumber": "Result Number",
      "performingProviderId": "Performing Provider ID",
      "verifiedByProviderId": "Verified By Provider ID",
      "verifiedAt": "Verified At",
      "specimenCollected": "Specimen Collected",
      "clinicalSignificance": "Clinical Significance",
      "recommendations": "Recommendations",
      "report": "Report",
      "addendum": "Addendum",
      "criticalAcknowledged": "Critical Acknowledged",
      "providerHash": "Provider #{{id}}",
      "acknowledgedAt": " at {{when}}",
      "specimenType": "Specimen Type",
      "grossDescription": "Gross Description",
      "microscopicDescription": "Microscopic Description",
      "accessionNumber": "Accession Number",
      "bodyRegion": "Body Region",
      "studyInstanceUid": "Study Instance UID",
      "cardiologyMeasurements": "Measurements",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "Loading results…",
    "loadError": "Failed to load results. Please try again.",
    "empty": "No results found for the selected filters.",
    "toast": {
      "acknowledgeSuccess": "Critical result acknowledged",
      "acknowledgeError": "Failed to acknowledge result"
    },
    "susceptibility": {
      "title": "Organisms and Susceptibilities",
      "antibiotic": "Antibiotic",
      "interpretation": "Interpretation",
      "mic": "MIC",
      "unnamedOrganism": "Unnamed organism",
      "noPanel": "No susceptibilities reported for this organism."
    },
    "components": {
      "value": "Value",
      "referenceRange": "Reference Range"
    }
  },
  "pending": {
    "title": "Pending Results",
    "countBadge_one": "{{count}} pending",
    "countBadge_other": "{{count}} pending",
    "autoRefresh": "Auto-refresh {{seconds}}s",
    "updated": "Updated {{when}}",
    "searchPlaceholder": "Search by patient name, MRN, or order…",
    "filtersButton": "Filters",
    "fields": {
      "orderType": "Order Type",
      "allTypes": "All Types",
      "priority": "Priority",
      "allPriorities": "All Priorities",
      "dateFrom": "Date From",
      "dateTo": "Date To"
    },
    "orderType": {
      "lab": "Lab",
      "imaging": "Imaging",
      "procedure": "Procedure",
      "consultation": "Consultation",
      "laboratory": "Laboratory",
      "radiology": "Radiology",
      "surgery": "Surgery",
      "therapy": "Therapy",
      "medication": "Medication",
      "admission": "Admission"
    },
    "aria": {
      "dateFrom": "Pending result date from",
      "dateTo": "Pending result date to"
    },
    "columns": {
      "patient": "Patient",
      "mrn": "MRN",
      "order": "Order",
      "type": "Type",
      "orderedBy": "Ordered By",
      "ordered": "Ordered",
      "expected": "Expected",
      "priority": "Priority"
    },
    "loading": "Loading pending results…",
    "loadError": "Failed to load pending results",
    "retry": "Retry",
    "empty": "No pending results found.",
    "awaitingResult": "Awaiting result",
    "specimenReceived": "Specimen received",
    "inLab": "In lab",
    "cancelledByLab": "Cancelled by lab",
    "overdue": "Overdue",
    "expectedBy": "Expected by {{date}}"
  },
  "critical": {
    "title": "Critical Results",
    "autoRefresh": "Auto-refresh {{seconds}}s",
    "updated": "Updated {{when}}",
    "unacknowledgedHeading_one": "{{count}} Unacknowledged Critical Value",
    "unacknowledgedHeading_other": "{{count}} Unacknowledged Critical Values",
    "escalationBanner": "These results require immediate physician acknowledgement.",
    "acknowledgeWithinMinutes": "Acknowledge within {{minutes}} minutes",
    "routeBackToProvider": "Route back to ordering provider",
    "attendingSignoff": "Requires attending sign-off",
    "searchPlaceholder": "Search by patient, test name…",
    "showAcknowledgedToggle": "Show acknowledged",
    "escalationTime": "T+{{minutes}}min",
    "criticalFallback": "CRITICAL",
    "loading": "Loading critical results…",
    "loadError": "Failed to load critical results",
    "empty": "No critical results pending acknowledgement.",
    "detailToggleLabel": "Show result detail",
    "openFullChart": "Open full chart",
    "columns": {
      "patient": "Patient",
      "mrn": "MRN",
      "test": "Test",
      "value": "Value",
      "impression": "Impression",
      "resultTime": "Result Time",
      "escalation": "Escalation",
      "acknowledged": "Acknowledged",
      "actions": "Actions"
    },
    "actions": {
      "acknowledge": "Acknowledge"
    },
    "toast": {
      "acknowledgeSuccess": "Critical result acknowledged",
      "acknowledgeError": "Failed to acknowledge result"
    },
    "refreshFailed": "Could not refresh — showing critical results as of {{when}}.",
    "incomplete": "Showing {{shown}} of {{total}} critical results. This list is incomplete."
  },
  "acknowledged": {
    "pending": "Acknowledgement pending",
    "acknowledged": "Acknowledged",
    "escalated": "Escalated",
    "expired": "Acknowledgement window expired"
  },
  "__review_acknowledged": "Escalation-state terminology varies by health system — verify with local clinical reviewer (candidates: SG MOH 'critical result acknowledgement', HK HA 'critical value notification', Japan 'パニック値の確認', Taiwan 'CDC 危急值通報', Korea '응급 결과 확인', Thai MOPH 'การรับทราบค่าวิกฤต'); window-expiry semantics in particular differ — some systems escalate to attending after the window, others to nursing supervisor.",
  "flowsheet": {
    "analyte": "Analyte",
    "empty": "No laboratory analytes to trend",
    "emptyHint": "Imaging, pathology and microbiology reports appear in the timeline view.",
    "trend": {
      "toggle": "Trend {{analyte}}",
      "referenceRange": "Reference {{range}}",
      "nonNumericOmitted_one": "{{count}} text result not plotted",
      "nonNumericOmitted_other": "{{count}} text results not plotted"
    }
  }
}
